import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { LocalizationContext } from './../../Context/LocalizationContext.js';
import { AuthContext } from './../../Context/AuthContext.js';
import { getRoleHome } from './../../helpers/roleHome.js';
import './../../Components/ErrorBoundary/ErrorBoundary.css';

const Error404Page = () => {

	const { t } = useContext(LocalizationContext);
	const { user } = useContext(AuthContext);

	return (
		<div className="eb-root eb-root--inline">
			<div className="eb-code">404</div>
			<h2 className="eb-title">{t('PublicNotFoundTitle')}</h2>
			<div className="eb-actions">
				<Link className="eb-btn eb-btn--primary" to={getRoleHome(user?.role)} replace>{t('PublicNotFoundHome')}</Link>
			</div>
		</div>
	);

};

export default Error404Page;
